// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const paymentsSlice = createSlice({
  name: "payments",
  initialState: {
    payments: [],
    contractTotal: 0,
    unsolvedPaymentsTotal: 0,
    isLoading: false,
    pagination: {
      count: 0,
      next: null,
      previous: null,
    },
  },
  reducers: {
    setPaymentsResult: (state, action) => {
      // action.payload structure: { data: [...payments array...], payments, contract_total, unsolved_payments_total, pagination }
      state.payments = action.payload.payments || action.payload.data || [];
      state.contractTotal = action.payload.contract_total || 0;
      state.unsolvedPaymentsTotal = action.payload.unsolved_payments_total || 0;
      state.pagination = action.payload.pagination || {
        count: 0,
        next: null,
        previous: null,
      };
    },
    setPayments: (state, action) => {
      state.payments = action.payload;
    },
    setContractTotal: (state, action) => {
      state.contractTotal = action.payload;
    },
    setUnsolvedPaymentsTotal: (state, action) => {
      state.unsolvedPaymentsTotal = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setPaymentsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearPayments: (state) => {
      state.payments = [];
      state.contractTotal = 0;
      state.unsolvedPaymentsTotal = 0;
      state.pagination = {
        count: 0,
        next: null,
        previous: null,
      };
    },
  },
});

export const {
  setPaymentsResult,
  setPayments,
  setContractTotal,
  setUnsolvedPaymentsTotal,
  setPagination,
  setPaymentsLoading,
  clearPayments,
} = paymentsSlice.actions;

export default paymentsSlice.reducer;
